import { EventModel } from './event-model.model';
import { User } from './user.model';
import { Model } from './model';
import * as moment from 'moment';
export class Camera extends Model {
  public _id: string;
  public name: string;
  public status: string;
  public clientVersion: string;
  public ip: string;
  public events: Array<EventModel>;
  public user: User;

  get attributeMap(): { [p: string]: any } {
    return {
      _id: String,
      name: String,
      token: String,
      status: String,
      clientVersion: String,
      ip: String,
      events: EventModel,
      user: User,
    };
  }

  get statusAttr() {
    if (this.status === 'offline') {
      return 'offline';
    }

    let is_on_stream = false;

    this.events.forEach((event) => {
      if (moment(event.start_date) < moment() && moment(event.end_date) > moment()) {
        is_on_stream = true;
      }
    });
    if (is_on_stream) {
      return 'on_stream';
    }
    // if (false) {
    //   return 'offline';
    // }
    return 'online';
  }

  get status_label() {
    if (this.statusAttr === 'online') {
      return 'Online';
    }
    if (this.statusAttr === 'offline') {
      return 'Offline';
    }
    if (this.statusAttr === 'on_stream') {
      return 'On Stream';
    }
  }
}



// WEBPACK FOOTER //
// /Users/dade/work/sportclubby/sportclubby.livestreaming.frontend/src/app/models/camera.model.ts